<template>

  <div class="float-w show" v-if="isShow">
    <div class="float--w">
      <div class="float-tt display-600 not-display-pc">
        <span class="zh">现场照片</span>
        <span class="en"></span>
      </div>
      <div class="btn-close" @click="close()">
        <img src="@/assets/images/icon-close-blk.png" alt="close"/>
      </div>
      <div class="main-slides-w">
        <swiper v-if="swiperOptionLiveFloat" :options="swiperOptionLiveFloat" ref="swiperTop">
          <swiper-slide v-for="(image,index) in images" :key="index">
            <div class="bbc-live">
              <img class="cover" :src="image.cover.b" alt="artist"/>
              <p class="hint">{{ image.alt }}</p>
            </div>
          </swiper-slide>
        </swiper>
        <div class="slides-navs">
          <div class="swiper-pagination swiper-pagination-live-f"></div>
          <div class="btn-nav nav-prev-live-f">
            <img src="@/assets/images/icon-ar-left-blk.png" alt="prev"/>
          </div>
          <div class="btn-nav nav-next nav-next-live-f">
            <img src="@/assets/images/icon-ar-left-blk.png" alt="prev"/>
          </div>
        </div>
      </div>
      <div class="sub-slides-w">
        <swiper v-if="swiperOptionLiveFloatThumbs" :options="swiperOptionLiveFloatThumbs" ref="swiperThumbs">
          <swiper-slide v-for="(image,index) in images" :key="index">
            <div class="bbc">
              <img class="cover" :src="image.cover.s" alt="artist"/>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  components: {},
  props: {
    index: {
      type: Number,
      default: null,
    },
    images: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      swiperOptions: null,
      // 浮层幻灯
      swiperOptionLiveFloat: null,
      swiperOptionLiveFloatThumbs: null,
      isShow: true,
      list: [],
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    this.show();
    this.$nextTick(() => {
      this.swiperOptionLiveFloatThumbs = {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 64,
        slidesOffsetAfter: 64,
        centeredSlides: true,
        slideToClickedSlide: true,
        breakpoints: {
          1600: {
            spaceBetween: 32,
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 24,
          }
        }
      };
      this.swiperOptionLiveFloat = {
        loop: false,
        effect: 'fade',
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination-live-f',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.nav-next-live-f',
          prevEl: '.nav-prev-live-f'
        },
      }
      setTimeout(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperThumbs.controller.control = swiperTop
        this.$refs.swiperTop.$swiper.slideTo(this.index, 0)
      }, 100)
    })
  },
  methods: {
    show() {
      this.isShow = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/exhibitionImages.vue